import React, { useEffect, useRef } from "react";
import "./Modal.scss";
import { useNavigate, useLocation } from "react-router-dom";

export interface Imodal {
  collapsed: boolean;
  children: any;
  onClose?: () => void;
  title?: string;
  subtitle?: string;
  disabledCloseButton?: boolean;
  onClick?: () => void;
  position?: number;
  classId?: string
  maxWidth?: string;
  light?: boolean;
  fullHeight?: boolean;
}

const FOCUSABLE_SELECTORS =
  'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

const Modal: React.FC<Imodal> = ({
  collapsed,
  children,
  onClose,
  title,
  subtitle,
  disabledCloseButton,
  onClick,
  position,
  maxWidth,
  light,
  fullHeight
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!collapsed) return;
    const container = containerRef.current;
    if (!container) return;

    const focusable = Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTORS));
    if (focusable.length > 0) focusable[0].focus();

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && onClose && !disabledCloseButton) {
        onClose();
        return;
      }
      if (e.key !== 'Tab' || focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [collapsed, onClose, disabledCloseButton]);

  return (
    <div
      ref={containerRef}
      className={`modal-wrapper ${collapsed ? "collapsed" : ""}`}
      onClick={onClick ? onClick : () => null}
      style={{ zIndex: position || 9999 }}
      role="dialog"
      aria-modal="true"
      aria-labelledby={title ? "modal-title" : undefined}
    >
      <div className="bg"></div>
      <div className="container-modal">
        <div
          className={`modal_block${light ? ' modal_block--light' : ''}${fullHeight ? ' modal_block--full-height' : ''}`}
          style={{ maxWidth: maxWidth || undefined }}
        >
          {onClose && currentPath !== '/inicio' && (
            <div className="btn-close">
              <button
                onClick={onClose}
                disabled={disabledCloseButton || false}
                aria-label="Cerrar"
              ></button>
            </div>
          )}
          <div className="modal-content-block">
            <div className="modal-header-block">
              {title && <h1 id="modal-title" className="modal_title">{title}</h1>}
              {subtitle && <p className="modal_subtitle">{subtitle}</p>}
            </div>

            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
